import _classCallCheck from "/var/lib/jenkins/workspace/GLOTIO_glotio-frontend_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/GLOTIO_glotio-frontend_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { CONSOLE_LEVELS, GLOBAL_OBJ, addInstrumentationHandler, severityLevelFromString, addExceptionMechanism, safeJoin } from '@sentry/utils';
/** Send Console API calls as Sentry Events */

var CaptureConsole = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  function CaptureConsole() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CaptureConsole);

    this.name = CaptureConsole.id;
    this._levels = options.levels || CONSOLE_LEVELS;
  }
  /**
   * @inheritDoc
   */


  _createClass(CaptureConsole, [{
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (!('console' in GLOBAL_OBJ)) {
        return;
      }

      var levels = this._levels;
      addInstrumentationHandler('console', function (_ref) {
        var args = _ref.args,
            level = _ref.level;

        if (!levels.includes(level)) {
          return;
        }

        var hub = getCurrentHub();

        if (!hub.getIntegration(CaptureConsole)) {
          return;
        }

        consoleHandler(hub, args, level);
      });
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'CaptureConsole';
    }
  }]);

  return CaptureConsole;
}();

CaptureConsole.__initStatic();

function consoleHandler(hub, args, level) {
  hub.withScope(function (scope) {
    scope.setLevel(severityLevelFromString(level));
    scope.setExtra('arguments', args);
    scope.addEventProcessor(function (event) {
      event.logger = 'console';
      addExceptionMechanism(event, {
        handled: false,
        type: 'console'
      });
      return event;
    });
    var message = safeJoin(args, ' ');
    var error = args.find(function (arg) {
      return arg instanceof Error;
    });

    if (level === 'assert') {
      if (args[0] === false) {
        message = "Assertion failed: ".concat(safeJoin(args.slice(1), ' ') || 'console.assert');
        scope.setExtra('arguments', args.slice(1));
        hub.captureMessage(message);
      }
    } else if (level === 'error' && error) {
      hub.captureException(error);
    } else {
      hub.captureMessage(message);
    }
  });
}

export { CaptureConsole };